import ManagersHub from "../../Containers/ManagersHub";

const ManagersHubPage = () => <ManagersHub />;

export default ManagersHubPage;
